import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FollowGroup } from '@app/models/follow-group';
import { ApiService } from '@app/services/api/api.service';
import {
  LoadFail,
  LoadSuccess,
  FollowGroupActionTypes
} from '@core/actions/follow-group.actions';

@Injectable()
export class FollowGroupEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(FollowGroupActionTypes.Load),
    switchMap(() =>
      this.api.getFollowGroups().pipe(
        map((followGroups: FollowGroup[]) => new LoadSuccess(followGroups)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  constructor(private actions$: Actions, private api: ApiService) {}
}
